class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.isMegaMenu = this.mainDetailsToggle.classList.contains('mega-menu');
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);

    if (this.isMegaMenu) {
      HeaderMenu.ensureOverlay();
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.querySelector('summary')?.addEventListener('click', this.onSummaryClick);
    }
  }

  static ensureOverlay() {
    if (HeaderMenu.overlay) return HeaderMenu.overlay;

    const overlay = document.createElement('div');
    overlay.className = 'mega-menu-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.textContent = '\u00A0';
    overlay.addEventListener('click', () => {
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (typeof menu.close === 'function') menu.close();
      });
    });
    document.body.appendChild(overlay);
    HeaderMenu.overlay = overlay;
    return overlay;
  }

  static syncOverlay() {
    const isOpen = Boolean(document.querySelector('header-menu details.mega-menu[open]'));
    document.body.classList.toggle('mega-menu-open', isOpen);
  }

  isDesktopHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches;
  }

  onMouseEnter() {
    if (!this.isDesktopHover()) return;
    window.clearTimeout(this.closeTimer);

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) {
        menu.mainDetailsToggle.removeAttribute('open');
        menu.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }
    });

    this.openMenu();
    HeaderMenu.syncOverlay();
  }

  onMouseLeave() {
    if (!this.isDesktopHover()) return;
    this.closeTimer = window.setTimeout(() => this.close(), 160);
  }

  onSummaryClick(event) {
    if (!this.isDesktopHover() || event.detail === 0) return;
    event.preventDefault();
    // Keep the hover-opened menu open; global.js flips aria-expanded before this
    // handler runs, so re-sync it to the actual open state after preventDefault.
    if (!this.mainDetailsToggle.open) {
      this.openMenu();
    } else {
      this.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    }
  }

  openMenu() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }

  close() {
    window.clearTimeout(this.closeTimer);
    super.close();
    if (this.isMegaMenu) HeaderMenu.syncOverlay();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.isMegaMenu) {
      this.content?.toggleAttribute('inert', !this.mainDetailsToggle.open);
      HeaderMenu.syncOverlay();
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
